import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type WindowSillsInstallationInfoData = {
  measurementUuid: string;
  typeOfInstallation: 'thumbAssembly' | 'assemblyWithoutThumb';
  oldWindowDismantlingInvestor: boolean;
  plasterProcessing: boolean;
  plasterType: 'wallFullFinishied' | 'gypsumPlaster' | 'traditionalPlaster';
  plannedAssemblyTime: string;
  numberOfAssemblyTeams: string;
  comments?: string;
};

const usePutWindowSillsInstallationInfo = (
  options?: UseMutationOptions<any, Error, WindowSillsInstallationInfoData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editWindowSillsInstallationInfo'],
    mutationFn: async (data) => {
      return axiosInstance
        .put('/measurement/window-sills/installation-info', data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych instalacji parapetów...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-window-sills-installation-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane instalacji parapetów zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-window-sills-installation-info',
      });
      queryClient.invalidateQueries({ queryKey: ['windowSillsInstallationInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych instalacji parapetów.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-window-sills-installation-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutWindowSillsInstallationInfo;
